import { useEffect, useMemo, useState } from 'react';
import { ORCHESTRATION_SPINNER_MESSAGES } from '../constants/orchestrationSpinnerMessages';

const INTERVAL_MS = 2200;

function hashSeed(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
}

/**
 * Rotaciona mensagens enquanto `active` é true; cada lead começa num índice diferente.
 */
export function useOrchestrationSpinner(active: boolean, leadId: string): string {
  const startOffset = useMemo(
    () => hashSeed(leadId) % ORCHESTRATION_SPINNER_MESSAGES.length,
    [leadId]
  );
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!active) {
      setTick(0);
      return;
    }
    setTick(0);
    const id = window.setInterval(() => {
      setTick((t) => (t + 1) % ORCHESTRATION_SPINNER_MESSAGES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [active, leadId]);

  const idx = (startOffset + tick) % ORCHESTRATION_SPINNER_MESSAGES.length;
  return ORCHESTRATION_SPINNER_MESSAGES[idx];
}
